import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8
  }} className="py-12 lg:py-16" data-id="element-51">
      <div className="max-w-lg mx-auto px-6" data-id="element-52">
        <div className="bg-[#F0F7F2] border border-[#1B6B3A]/20 rounded-lg p-6 lg:p-8 text-center" data-id="element-53">
          <div className="inline-flex items-center justify-center p-3 bg-[#1B6B3A]/10 rounded-full mb-4" data-id="element-54">
            <ShieldCheck className="w-6 h-6 text-[#1B6B3A]" data-id="element-55" />
          </div>

          <h3 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-3" data-id="element-56">
            30-Day Money-Back Guarantee
          </h3>

          <p className="text-sm lg:text-base text-[#3D3D3D] leading-relaxed" data-id="element-57">
            If Closing Number Lock doesn't help you feel more in control of your
            closing process, email us within 30 days for a full refund. No
            forms. No questions. No hassle.
          </p>
        </div>
      </div>
    </motion.section>;
}